export default "__VITE_ASSET__C$zNXDWw__"